(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/ball-row/assets/javascripts/sorter/sorter.js') >= 0) return;  svs.modules.push('/components/tur/ball-row/assets/javascripts/sorter/sorter.js');

'use strict';

svs.tur = svs.tur || {};
svs.tur.ball.row = svs.tur.ball.row || {};
svs.tur.ball.row.sorter = svs.tur.ball.row.sorter || {};


class Sorter {
  constructor() {
    window.addEventListener('resize', () => this._updateProperties());
  }
  _updateProperties() {
    var _this$elements;
    (_this$elements = this.elements) === null || _this$elements === void 0 || _this$elements.forEach(element => {
      TweenLite.set(element.$el, {
        x: 0,
        y: 0
      });
      const rowProps = element.$el;
      element.x = rowProps.offsetLeft;
      element.y = rowProps.offsetTop;
    });
  }
  _numerical() {
    return (a, b) => a - b;
  }

  _animate() {}
}
svs.tur.ball.row.sorter.Sorter = Sorter;

 })(window);